module.exports = __webpack_public_path__ + "images/places/asm_61-e5ede382631942dbf0bbb24672cad54f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_61.jpg
 ** module id = 310
 ** module chunks = 0
 **/